import React, { useEffect } from 'react'

import useContextMenu from 'conversations/hooks/useContextMenu'

import { Portal } from '@driftt/conversation-components'

import styles from './styles.module.css'

export interface ContextMenuActions {
  label: string
  onClick: (e: any) => void
  dataOcwebId: string
}

interface Props {
  outerRef: React.RefObject<any>
  actions: ContextMenuActions[]
  setContextMenuActive?: (val: boolean) => void
}

const ContextMenu: React.FC<Props> = ({ outerRef, actions, setContextMenuActive }) => {
  const { xPos, yPos, showMenu } = useContextMenu(outerRef)

  useEffect(
    () => setContextMenuActive && setContextMenuActive(showMenu),
    [setContextMenuActive, showMenu]
  )

  const Menu: React.FC = () => (
    <Portal>
      <div className={styles.menuContainer} style={{ position: 'fixed', top: yPos, left: xPos }}>
        <div className={styles.menu}>
          {actions.map(({ onClick, label, dataOcwebId }) => (
            <div
              key={dataOcwebId}
              className={styles.item}
              onClick={onClick}
              data-ocweb-id={dataOcwebId}>
              {label}
            </div>
          ))}
        </div>
      </div>
    </Portal>
  )

  return showMenu ? <Menu /> : null
}

export default ContextMenu
